import Header from '../Header1';
import "../../styles/grid.css";
import Vector from "../../assets/svg/editIcon.svg";
import Delete from "../../assets/svg/DeleteIcon.svg";
import { useState, useRef, useEffect } from "react";
import DatePicker from "../../Component/DatePicker";
import ReactPaginate from "react-paginate";
import axiosInstance from '../../axiosInstance';
import CostElementPopup from './CostElementPopup';
import { ToastContainer, toast } from "react-toastify";
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';
import CommonFooter from '../../CommonFooter/CommonFooter';
import { useGlobal } from '../../GlobalContext';

const CostType = () => {

  const { rolePermissionList } = useGlobal();

  // True when the role has the given permission for the named menu.
  const checkPermission = (menuName, permission) =>
    rolePermissionList.some((element) => element.name === menuName && element[permission] === true);

  const [tableData, setTableData] = useState([]);
  const [error, setError] = useState(null);
  const [limit, setLimit] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const [skip, setSkip] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [editData, setEditData] = useState(null);
  const [reload, setReload] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const popupRef = useRef(null);

  const fetchCostType = async (search = '') => {
    try {
      const response = await axiosInstance.get(`/costsolution/costelement`, {
        params: { limit, skip, search }
      });
      const data = response.data;
      if (Array.isArray(data.costelement)) {
        setTableData(data.costelement);
        setTotal(data.totalCount || 0);
        setTotalPages(Math.ceil((data.totalCount || 0) / limit));
      } else {
        setTableData([]);
      }
    } catch (error) {
      setError(error.message);
      console.error("Error fetching cost elements:", error);
      toast.error("Failed to fetch cost elements");
    }
  };

  useEffect(() => {
    fetchCostType(searchTerm);
  }, [skip, limit, reload, searchTerm]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        closePopup();
      }
    };
    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpen]);

  const handleAddNewClick = (row) => {
    setEditData(row ? { id: row.id } : null);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setEditData(null);
    setIsPopupOpen(false);
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    setLimit(newLimit);
    setCurrentPage(0);
    setSkip(0);
  };

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
    setSkip(selected * limit);
  };

  const handleSelectAll = () => {
    setSelectedRows(selectedRows.length === tableData.length ? [] : tableData.map(row => row.id));
  };

  const handleRowSelect = (id) => {
    setSelectedRows(prev =>
      prev.includes(id) ? prev.filter(rowId => rowId !== id) : [...prev, id]
    );
  };

  const handleDeleteRow = (id) => {
    setDeleteId(id);
    setConfirmOpen(true);
  };

  const confirmDelete = async () => {
    if (!deleteId) return;
    try {
      await axiosInstance.delete(`/costsolution/costtype/delete/${deleteId}`);
      toast.success("Row deleted successfully!");
      setTableData(prev => prev.filter(row => row.id !== deleteId));
      setTotal(prev => prev - 1);
      setSelectedRows(prev => prev.filter(id => id !== deleteId));
      setReload(prev => !prev);
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Something went wrong while deleting!");
    } finally {
      setConfirmOpen(false);
      setDeleteId(null);
    }
  };

  const cancelDelete = () => {
    setConfirmOpen(false);
    setDeleteId(null);
  };

  // Common search handler
  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentPage(0);
    setSkip(0);
  };

  const isAllSelected = selectedRows.length === tableData.length && tableData.length > 0;
  const isAnySelected = selectedRows.length > 0;

  return (
    <>
      <Header onSearch={handleSearch} />
      <div className="container">
        <div className="header">
          <div className="left-header">
            <h3>All Cost Element ({total})</h3>
          </div>
          <div className="right-header">

            {checkPermission("Cost Element", "create_permission") && !isAnySelected && (
              <button id="addNewBtn" onClick={handleAddNewClick}>
                Add New
              </button>
            )}
          </div>
        </div>

        <div className="table-container" style={{ overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth', marginTop:"0px" }}>
          <table>
            <thead>
              <tr>
                <th style={{ width: "1px" }}>
                  <input type="checkbox" checked={isAllSelected} onChange={handleSelectAll} />
                </th>
                <th>S.No</th>
                <th>Code</th>
                <th>Name</th>
                <th> Category</th>
                <th>Cost Type</th>
                <th>Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {tableData.length > 0 ? (
                tableData.map((row, index) => (
                  <tr key={row.id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedRows.includes(row.id)}
                        onChange={() => handleRowSelect(row.id)}
                      />
                    </td>
                    <td>{skip + tableData.indexOf(row) + 1}</td>
                    <td>{row.code}</td>
                    <td>{row.name}</td>
                    <td>{row.categorycode}</td>
                    <td>{row.costType}</td>
                    <td>{row.modifieddate}</td>
                    <td>
                      <div className="actions">

                        {checkPermission("Cost Element", "edit_permission") && (
                          <span className="edit-icon">
                            <img
                              src={Vector}
                              alt="Edit Icon"
                              width="20"
                              height="20"
                              onClick={() => handleAddNewClick(row)} // ✅ Passes row data correctly
                            />
                          </span>
                        )}


                        {checkPermission("Cost Element", "delete_permission") && (
                          <span
                            className="delete-icon"
                            onClick={() => handleDeleteRow(row.id)} // Ensure this matches the function name
                            style={{ cursor: "pointer" }}>
                            <img src={Delete} alt="Delete Icon" width="40" height="40" />
                          </span>
                        )}
                      </div>
                    </td>
                  </tr>
                ))) : (
                <tr>
                  {searchTerm && tableData.length === 0 && (
                    <td colSpan="7" style={{ textAlign: 'center', padding: '20px', fontSize: '14px', color: '#666' }}>
                      No Cost Elements found matching "{searchTerm}"
                    </td>
                  )}
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="pagination-container d-flex align-items-center justify-content-between mt-3">
          <div className="Limit-Dropdown">
            <label htmlFor="limit" className="fw-semibold">Items per page:</label>
            <select
              id="limit"
              value={limit}
              onChange={handleLimitChange}
              className="form-select d-inline w-auto" >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
            </select>
          </div>

          <div className="d-flex align-items-center gap-4">
            <ReactPaginate
              previousLabel={<span style={{ userSelect: "none" }}>Previous</span>}
              nextLabel={<span style={{ userSelect: "none" }}>Next</span>}
              pageCount={totalPages > 0 ? totalPages : 1}
              onPageChange={handlePageClick}
              containerClassName={"pagination d-flex"}
              activeClassName={"active"}
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              forcePage={currentPage}
            />
          </div>
        </div>
      </div>

      {isPopupOpen && (
        <div className="popup-overlay">
          <div className="popup-content" ref={popupRef}>
            <CostElementPopup closePopup={closePopup} editData={editData} triggerReload={() => setReload(prev => !prev)} />
          </div>
        </div>
      )}
      <CommonFooter />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      <ConfirmDialog
        open={confirmOpen}
        title="Delete Confirmation"
        message="Are you sure you want to delete this cost element?"
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
      />
    </>
  );
};

export default CostType;
